var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarAlgorithm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.001,
    height: 20.001,
    viewBox: "0 0 20.001 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-0.999 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M-1512.668-8792.332a4.335,4.335,0,0,1,4.335-4.335,4.334,4.334,0,0,1,4.333,4.335,4.334,4.334,0,0,1-4.333,4.333A4.335,4.335,0,0,1-1512.668-8792.332ZM-1523-8788a1,1,0,0,1-1-1v-6.667a1,1,0,0,1,1-1h6.667a1,1,0,0,1,1,1V-8789a1,1,0,0,1-1,1Zm11.333-11.334a1,1,0,0,1-1-1V-8807a1,1,0,0,1,1-1H-1505a1,1,0,0,1,1,1v6.669a1,1,0,0,1-1,1Zm-11.333,0a1,1,0,0,1-1-1V-8807a1,1,0,0,1,1-1h6.667a1,1,0,0,1,1,1v6.669a1,1,0,0,1-1,1Z",
    transform: "translate(1525 8809)",
    fill: "#a39cc8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarAlgorithm);
export default __webpack_public_path__ + "static/media/sidebarAlgorithm.8acc8872.svg";
export { ForwardRef as ReactComponent };